import React from 'react';

const ClientsBanner: React.FC = () => {
  const clients = [
    { name: 'Ministry of Transport and Communications', logo: 'https://res.cloudinary.com/durgvddoz/image/upload/v1755771317/ministry_of_transport_zwc9gz.png', country: 'Qatar' },
    { name: 'Qatar Investment Authority (QIA)', logo: 'https://res.cloudinary.com/durgvddoz/image/upload/v1755771320/qatar_investment_authoritypng_kbf56y.png', country: 'Qatar' },
    { name: 'Kuwait Oil Company', logo: 'https://res.cloudinary.com/durgvddoz/image/upload/v1755771319/Kuwait-Oil-Company-1_nzuluf.png', country: 'Kuwait' },
    { name: 'Central Bank of Oman', logo: 'https://res.cloudinary.com/durgvddoz/image/upload/v1755787386/Central_Bank_of_Oman_logo_oaghts.png', country: 'Oman' },
    { name: 'Kuwait International Bank (KIB)', logo: '💳', country: 'Kuwait' },
    { name: 'Qatar Central Bank', logo: '🏛️', country: 'Qatar' },
    { name: 'State of Qatar – Ministry of Interior', logo: '🛡️', country: 'Qatar' },
    { name: 'Ministry of Finance (Qatar)', logo: '💼', country: 'Qatar' },
    { name: 'Saudi Central Bank (SAMA)', logo: '🏦', country: 'Saudi Arabia' },
    { name: 'ADNOC (Abu Dhabi National Oil Company)', logo: '⛽', country: 'UAE' },
    { name: 'Q-CERT', logo: '🔒', country: 'Qatar' },
    { name: 'RedQ', logo: '🔴', country: 'Global' },
    { name: 'QFB (Qatar First Bank)', logo: '🏪', country: 'Qatar' },
    { name: 'Vodafone', logo: '📱', country: 'Global' },
    { name: 'Petroleum Development Oman', logo: '🛢️', country: 'Oman' },
    { name: 'Emirates Nuclear Energy Corporation', logo: '⚛️', country: 'UAE' },
    { name: 'QNB (Qatar National Bank)', logo: '🏦', country: 'Qatar' },
    { name: 'Qatar Airways', logo: '✈️', country: 'Qatar' },
    { name: 'North Oil Company', logo: '🛢️', country: 'Qatar' },
    { name: 'SDAIA (Saudi Data & AI Authority)', logo: '🤖', country: 'Saudi Arabia' }
  ];

  return (
    <section className="py-16 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            🌍 Global Clients
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Trusted by government institutions, financial organizations, and enterprises across the Middle East
          </p>
        </div>
        
        <div className="relative">
          <div className="flex animate-scroll space-x-8">
            {/* First set of clients */}
            {clients.map((client, index) => (
              <div
                key={index}
                className="flex-shrink-0 bg-white rounded-xl shadow-sm border border-slate-200 p-6 w-80 hover:shadow-lg transition-shadow"
              >
                <div className="text-center">
                  {client.logo.startsWith('http') ? (
                    <div className="h-16 w-16 mx-auto mb-3 flex items-center justify-center">
                      <img 
                        src={client.logo} 
                        alt={`${client.name} logo`}
                        className="max-h-full max-w-full object-contain"
                      />
                    </div>
                  ) : (
                    <div className="text-4xl mb-3">{client.logo}</div>
                  )}
                  <h3 className="font-semibold text-slate-900 mb-1 text-sm leading-tight">{client.name}</h3>
                  <p className="text-xs text-blue-600 font-medium">{client.country}</p>
                </div>
              </div>
            ))}
            {/* Duplicate set for seamless scrolling */}
            {clients.map((client, index) => (
              <div
                key={`duplicate-${index}`}
                className="flex-shrink-0 bg-white rounded-xl shadow-sm border border-slate-200 p-6 w-80 hover:shadow-lg transition-shadow"
              >
                <div className="text-center">
                  {client.logo.startsWith('http') ? (
                    <div className="h-16 w-16 mx-auto mb-3 flex items-center justify-center">
                      <img 
                        src={client.logo} 
                        alt={`${client.name} logo`}
                        className="max-h-full max-w-full object-contain"
                      />
                    </div>
                  ) : (
                    <div className="text-4xl mb-3">{client.logo}</div>
                  )}
                  <h3 className="font-semibold text-slate-900 mb-1 text-sm leading-tight">{client.name}</h3>
                  <p className="text-xs text-blue-600 font-medium">{client.country}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      <style>{`
        .animate-scroll {
          animation: scroll 30s linear infinite;
        }
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
};

export default ClientsBanner;